import type { TFunction } from "i18next";
import type { AccountState, AccountWait } from "../../../api/accountsApi";

/** An account's state in a word, wherever it is listed: a pending one by what the server says
 * it waits for (F133, GP-6), so an approval that is due reads as such everywhere. */
export function accountStatus(t: TFunction, state: AccountState, waitsFor: AccountWait | null): string {
  return waitsFor === "approval" ? t("administration.accounts.states.pending_approval") : t(`administration.accounts.states.${state}`);
}
